import { completeGenericJob, failGenericJob, updateGenericJobProgress } from "../../store/jobsSlice";
import { AppDispatch } from "../../store/store";
import { store } from "../../store/store";
import { api } from "../api";

const POLLING_INTERVAL = 3000;
class GenericJobService {
  private static instance: GenericJobService;
  private pollingInterval: ReturnType<typeof setInterval> | null = null;
  private dispatch: AppDispatch;

  private constructor(dispatch: AppDispatch) {
    this.dispatch = dispatch;
  }

  static getInstance(dispatch?: AppDispatch): GenericJobService {
    if (!GenericJobService.instance) {
      if (!dispatch) {
        throw new Error(
          "JobService needs dispatch function for initialization"
        );
      }
      GenericJobService.instance = new GenericJobService(dispatch);
    }
    return GenericJobService.instance;
  }

  ensurePolling(){
    if(this.pollingInterval) return;
    this.pollingInterval = setInterval(async () => {
      const activeGenericJobs = Object.values(store.getState().jobs.activeGenericJobs).filter(el => el.status === "running" || el.status === "idle");
      for(const job of Object.values(activeGenericJobs)){
        try {
          if(job.trackingId === "123"){
            const progress = Math.random() * 100;
            this.dispatch(updateGenericJobProgress({identifier: job.identifier, progress}))
            continue;
          }


          const response = await this.checkJobProgress(job.trackingId);
          if(response.data?.status === "completed"){
            this.dispatch(completeGenericJob({identifier:job.identifier, payload: response.data?.response}))
          }else if(response.data?.status === "failed"){
            this.dispatch(failGenericJob({identifier: job.identifier, reason: response.data?.message}))
          }
          this.dispatch(updateGenericJobProgress({identifier: job.identifier, progress: response.data?.progress ?? 0}))
          
        } catch (error) {
          this.dispatch(failGenericJob({identifier: job.identifier, reason: error instanceof Error ? error.message : "Unknown error"}))
        }
      }
    }, POLLING_INTERVAL)
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  }

  private async checkJobProgress(jobId: string) {
      return await api.getJobStatus(jobId);
    }
}

GenericJobService.getInstance(store.dispatch);
export { GenericJobService };

